module.exports = __webpack_public_path__ + "static/media/shop-cart.c6db6521.svg";